import { render, staticRenderFns } from "./ym-put.vue?vue&type=template&id=57632a5e&scoped=true&"
import script from "./ym-put.vue?vue&type=script&lang=js&"
export * from "./ym-put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57632a5e",
  null
  
)

export default component.exports